import { useMutation, useQuery } from 'react-query';

import {
  createSalesLead,
  getMyLeads,
  assignSales,
  getSales,
  getSalesUsers,
  editLead,
  importLeads,
  exportLeads,
  bulkEditLeads,
} from '~/api/sales';
import { usePageQuery } from '~/hooks';

export const useGetMyLeads = () => {
  return usePageQuery('my-leads', getMyLeads);
};

export const useCreateNewSalesLead = () => {
  return useMutation(createSalesLead);
};

export const useAssignSales = () => {
  return useMutation(assignSales);
};

export const useSales = () => {
  return useQuery('salesAssignee', getSales, { staleTime: Infinity });
};

export const useSalesUsers = () => {
  return useQuery('salesUsers', getSalesUsers, { staleTime: Infinity });
};

export const useEditSalesLead = () => {
  return useMutation(editLead);
};

export const useImportLeads = () => {
  return useMutation(importLeads);
};

export const useExportLeads = () => {
  return useMutation(exportLeads);
};

export const useBulkEditLeads = () => {
  return useMutation(bulkEditLeads);
};
